import React, { useState } from 'react'
import Checkbox from '../../components/Checkbox';
import { InnerBGWrap } from './styled';

const CheckContainer = ({ setState, Type, imgUrl, isChecked }) => {
    
    const [ isOpen, setIsOpen] = useState(false);
  
    const openHandler = () => {
      setIsOpen(prev => !prev)
    }

    const checkHander = () => {   
      if (Type === 'Type1') {
        return setState(prev => ({...prev, checkType1: !prev.checkType1}));
      }
      setState(prev => ({...prev, checkType2: !prev.checkType2}));
    };

    const matchMessage = () => {
        if(Type === 'Type1') return '(필수) 개인정보 수집 동의';
        return '(필수) 개인 정보 제3자 제공에 대한 별도 동의';
    }

    return (
        <div style={{ marginBottom: '18px' }}>
          <Checkbox 
            isOpen={isOpen} 
            openHandler={openHandler}  
            isChecked={isChecked} 
            checkHander={checkHander}
            message={matchMessage()} />
          {isOpen && (
            <InnerBGWrap width={600} height={168} imgUrl={imgUrl} />
          )}
        </div>
    )
}
export default CheckContainer;